export default {
  termsError: {
    marginLeft: "15px",
    color: "#F44335",
    display: "flex",
    width: "100%",
    fontSize: "11px",
  },
  privacy_policy: {
    display: 'block',
    marginTop: "12px",
    "& .link-terms": {
        cursor: 'pointer',
        color: 'inherit'
        // textDecoration: 'underline'
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/StartContainer/TermsPrivacyField/TermsPrivacyField.style.js